import React from "react";
var __jsx = React.createElement;
export var AppointmentDateTime = function AppointmentDateTime(_ref) {
  var day = _ref.day,
    month = _ref.month,
    time = _ref.time,
    year = _ref.year,
    _ref$classes = _ref.classes,
    classes = _ref$classes === void 0 ? "" : _ref$classes;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center shrink-0 h-9 w-9 rounded-lg border text-center ".concat(classes)
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-[20px] font-medium leading-[1.3] text-gray-200"
  }, day), /*#__PURE__*/React.createElement("div", {
    className: "text-xs font-medium text-gray-200"
  }, month, " ", year), /*#__PURE__*/React.createElement("div", {
    className: "text-[10px] font-medium text-gray-400"
  }, time));
};